import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Eye, MessageSquare, Scale, GitMerge } from 'lucide-react';
const BENEFITS = [{
  icon: Eye,
  title: 'Advice before signing',
  desc: 'Risks, special conditions and obligations explained while you can still act on them.'
}, {
  icon: MessageSquare,
  title: 'Plain-English explanations',
  desc: 'What the contract actually means for your situation, without the legal fog.'
}, {
  icon: Scale,
  title: 'Legal capability when it counts',
  desc: 'The authority and experience to handle a matter when it moves past paperwork.'
}, {
  icon: GitMerge,
  title: 'One coordinated process',
  desc: 'The same team from first contract review through to settlement and completion.'
}];
export function Differentiation() {
  return <section className="py-10 md:py-14 px-5 md:px-6 bg-cream" data-id="element-230" data-mp="2z6lvzksjadap">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-start" data-id="element-231" data-mp="338z0k5vjo55w">
        <div data-id="element-232" data-mp="2byd1of9nn6n3">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-233" data-mp="2byv5bwyncn51">
            the honest bit
          </p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-234" data-mp="2713b2waj4oxo">
            Conveyancing is routine, until it isn't.
          </h2>
          <p className="mt-6 text-lg text-muted-ink leading-relaxed" data-id="element-235" data-mp="1xb1o67twxckc">
            A transaction can change quickly when a title issue, an unsuitable
            special condition, a disclosure problem or an ownership-structure
            question appears. L.A Property Law combines conveyancing process
            management with access to legal advice when the matter needs more
            than paperwork.
          </p>
          <div className="mt-8" data-id="element-236" data-mp="1ecpbwd7pfmkj">
            <Link to="/about" data-id="element-237" data-mp="1edqr8tvr6v82">
              <Button variant="primary" data-id="element-238" data-mp="3dp06b9sw5c6r">See how we work</Button>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-239" data-mp="38q6wpsgq65bv">
          {BENEFITS.map(b => {
          const Icon = b.icon;
          return <div key={b.title} className="h-full rounded-2xl bg-surface border border-border p-5" data-id="element-240" data-mp="16zgh455p70rh">
                <div className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-brand-blue-light text-brand-blue mb-5" data-id="element-241" data-mp="x33lv2ui8eum">
                  <Icon className="w-6 h-6" strokeWidth={2} data-id="element-242" data-mp="1226grugrt4ov" />
                </div>
                <h3 className="font-serif text-xl text-ink mb-2" data-id="element-243" data-mp="1psalk55p3ahg">{b.title}</h3>
                <p className="text-muted-ink leading-relaxed" data-id="element-244" data-mp="1uqvle3h1bs5d">{b.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}